import { defineStore } from 'pinia';

// Dashboard theme. Dark is the default; a customer's choice is remembered in this browser.
// The <body class="dark"> is what the stylesheet keys off, and theme.css holds both token sets.
const KEY = 'dark';

const storedIsDark = () => {
    try { return localStorage.getItem(KEY) !== 'false'; } catch (e) { return true; }   // private windows
};

const applyToBody = (isDark) => {
    document.body.classList.toggle('dark', isDark);
};

export const useDarkModeStore = defineStore('dark', {
    state: () => ({
        isDarkMode: storedIsDark(),
    }),
    actions: {
        // called once when the app starts, before anything is painted
        applyStoredTheme() {
            this.isDarkMode = storedIsDark();
            applyToBody(this.isDarkMode);
        },
        setDarkMode(isDark) {
            this.isDarkMode = Boolean(isDark);
            applyToBody(this.isDarkMode);
            try { localStorage.setItem(KEY, this.isDarkMode.toString()); } catch (e) { /* the choice just will not stick */ }
        },
        toggleDarkMode() {
            this.setDarkMode(!this.isDarkMode);
        },
    },
});
